module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/title.jpg"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "h3-1"
  }, [_c('em', [_vm._v("The Making of a Polish Actress")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The Poland of "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Modrzejewska’s youth was politically turbulent and socially stultifying, possessed of an inspiring past and mired in a present of poverty and oppression. The Polish empire had flourished for centuries under the Jagiellonian dynasty (1385–1569) and as the Republic of Poland-Lithuania (1569–1795), boasting prosperous cities, a powerful army, major achievements in the arts and sciences, and a Statute of General Toleration guaranteeing safe haven for Jews, Muslims, and Protestants as well as Catholics. By the eighteenth century, however, the Republic’s wars against the Russians, Swedes, and Prussians had emptied the state’s coffers, and its landed aristocrats further weakened the state’s infrastructure by diverting their fortunes into their own estates. In 1795, the armies of Prussia, Russia, and Austria finally wiped the Republic off the European map, dividing its lands into three occupied partitions. The Russian partition claimed the capital Warsaw, while the Austrian partition, also known as Galicia, included the city of Lwów (now Lviv in Ukraine) and Poland’s historic capital of Kraków.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Despite their separate zones of occupation, Poles preserved “the mind of a large nation in a stateless body” and acted out in consequence."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" They mounted several uprisings against their scorned oppressors in the nineteenth century. Modrzejewska was born in the inter-uprising period—between the November 1830 uprising and the January 1863 revolt, both of which began in the Russian partition, drew participants from elsewhere in occupied Poland, and ended in bitter defeat, as rebels were executed, exiled to Siberia, or conscripted into the Russian army to serve in the empire’s most dangerous outposts. Although her hometown of Kraków remained a free city until 1846, when a local uprising angered the authorities, the young Helena endured the city’s greatest political and natural trials—Austrian bombardment, the imposition of martial law, several cholera epidemics, and the great 1850 fire which destroyed “one hundred sixty-five houses, four churches, and three convents.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" As she would insist in later accounts, she early on imbibed a fervent patriotism and survived adversity with staunch resolution and a great deal of hard work.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/19.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Wawel Castle overlooking the Vistula River. From "), _c('em', [_vm._v("Memories and Impressions of Helena Modjeska")]), _vm._v(", 1910")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("The Kraków of her first decades also confronted her with more problematic challenges which she more or less overcame by temperament and talent. Established as the imperial capital from the eleventh through the sixteenth centuries, Kraków grew into a museum city, accruing impressive monuments of different architectural styles, from the Gothic St. Mary’s Church, situated on the main city square, to the Renaissance castle looming above the city on Wawel Hill. As the Austrians installed their defensive walls and garrisons, these monuments were left to decay, and city streets and buildings became defaced by dirt and trash."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Through most of the 1840s and 1850s, Kraków was a sorry mess of crumbling grandeur, modest dwellings, and Austrian fortifications, poorly lit and strewn with garbage, and its once great Cloth Hall on the market square barnacled with little shops and stalls and verging on collapse."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Nevertheless, as the actress later avowed, she saw only the beauty beneath this disfigurement and daydreamed about the city’s glorious history as she wandered its dirty streets.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("By mid-century, Kraków likewise had deteriorated into a stuffy little provincial city, dominated socially by an exclusive set of aristocratic families, observant of a strict class hierarchy, and bound by puritanical rules of respectable behavior, punctiliously observed by middle-class young women. Modrzejewska would not be equipped to scale this hierarchy until the late 1860s, when Kraków society itself grew more progressive and she could reign on a reformed city stage expressly supported by aristocrats. In the preceding decades she would have contended with strong local prejudices against actresses as women of little education and low morals who regularly enjoyed the material support of their “protectors.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modrzejewska’s Polish biographers emphasize how her unclear parentage and poverty must have shamed her in her youth. Describing Kraków as the sort of place where “everyone knew everything about everyone,” Tymon Terlecki guesses that the young Helena was mortified by rumors of her illegitimacy and later gravitated to her seducer Zimajer as a kind of surrogate father."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Jerzy Got is definite about how the decline in her family’s fortunes scarred their psyche: “Memories of the superiority and respect they recently enjoyed exaggerated their current situation and led them to indifference, despair, and helpless revolt.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" In fact, there is scant documentation as to how the young Helena felt."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" But it should be borne in mind that her early experiences were also filtered through the stories, reactions, and examples of her unusual family.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("THE FAMILY BENDA")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("When the great Kraków theater director Stanis"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aw Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian paid tribute to Helena’s favorite sibling, the actor Feliks Benda, soon after his premature death in 1875, he praised Feliks’s father Szymon Benda as a solid citizen, “an affluent burgher ("), _c('em', [_vm._v("mieszczanin")]), _vm._v(") who had acquired something of an estate and, as is usually the case with us, subsequently lost a good part of it serving the city and the Republic.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" In her memoirs, Modjeska claims that Szymon was ennobled for his efforts."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Whatever his actual class, Szymon Benda left his much "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("younger wife Józefa a reduced, if adequate, estate of two houses to support her and their three surviving sons, Józef, Szymon, and Feliks. Józefa lived for several years after her husband’s death as a respectable burgher’s widow and an able manager, providing her family with the proper advantages. One of her sons—the talented Feliks—attended the prestigious Kraków gymnasium of St. Anne’s, and her husband’s surviving namesake, Szymon, studied music in Vienna."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Her family only fell on hard times when the great fire of 1850 swept through the city center and destroyed her properties—both her income and home."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Thereafter they subsisted on the earnings of the little coffeehouse Józefa had had the foresight to establish before the fire, a business she herself managed."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Józefa Bendowa was less vigilant in abiding by the moral code of Kraków’s middle class. After Szymon’s death and before wedding her second husband, Micha"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v(" Opid, she gave birth to Helena, who was listed by her mother’s maiden name of Mizel (Misel) on legal documents and christened Bendówna (the maiden form of the Benda surname) when she was already six years old. Józefa Bendowa was Opid’s wife when she bore her next child in 1842, Helena’s younger sister Józefa or Józia. Opid, who died in 1845 at the age of 39, was the gentle man whom Helena knew and publicized as her legitimate father. Yet rumors circulated that Kraków aristocrat Prince W"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("adys"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aw Sanguszko had sired her, and over the years these were reinforced by the strong resemblance between the lovely actress and Sanguszko’s legitimate daughter, another beauty named Helena."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("While Kraków society regarded her as a bastard of uncertain paternity, Helena was loved, accepted, and recruited for duty in a family where illegitimacy seemed to bear no stigma. Helena’s half-brother Feliks married a woman whose illegitimate daughter he adopted. Her half-brother Józef not only had a child with his wife before they married, but also abandoned the two just before his wife died. Curiously enough, one of Modrzejewska’s later admirers, the memoirist Maria Kietli"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ska, described her mother’s shocked discovery of Józef’s sick wife lying on a torn straw pallet in a dirty room, while her three-year-old daughter played beside her."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" After the poor woman’s death, her child, Stanis"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("awa (Stasia) Benda, became the special charge of her thirteen-year-old Aunt Helena.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Like other actress-authors of her day, Modjeska omits any reference to sexually immoral behavior in her memoirs."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The tales of her past that she and her intimates leaked to eager celebrity biographers were similarly censored."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("Yet Modjeska also mentions no professional or social restrictions on women’s proper behavior, beginning with her mother’s portrait. A working woman and strong head of household, Józefa paid no heed to the domestic focus and narrow social circulation expected of middle-class ladies. Instead she presented an immensely useful role model to her aspiring daughter. Modjeska accepted that she “could not claim the exclusive attention” of a mother busy overseeing household and business, and she proudly states that Józefa had “established a perfect order in her affairs” before the debacle of the 1850 fire. In a quick sketch, Modjeska refers to Józefa’s once remarkable beauty and characterizes her as “a person of great energy, great activity, very quick and outspoken, very generous, but rash in judgment, and often regretting her hasty words and actions.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Józefa appears intermittently in the first part of "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(" as a de facto paterfamilias and a surprisingly modern professional mentor. Her stern mother discourages Helena’s early passion for the stage, forbidding her the theater after a first visit leaves the girl “blind, mute and deaf” to the world, and forbidding her at-home theatricals after she and her half-brother Adolf perform an “absurd” melodrama of their own concoction."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Józefa did believe in “self-support for women,” but she urged Helena to train as a teacher, the sort of pragmatic advice that Helena herself would mete out in her later years."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Once her daughter had succeeded onstage, however, Józefa immediately backed her enterprise, sometimes joining her on tour to care for her grandchildren. Helena’s correspondence indicated that she leaned on Józefa as confidante, caregiver, and all-purpose factotum, the first in a series as she traveled the world. She also gauged her capacity for work on her mother’s stalwart example. In a letter written to relatives four years before her own death in 1909, Modjeska tried to calculate how much longer she would be able to cover her extended family’s enormous expenses given the fact that “I am so much like my mother.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Józefa clearly modeled a life of industry and efficiency for Helena, but Helena’s calculations were in vain. The hardworking mother outlived her harder-working daughter by fifteen years.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Józefa’s relative absence in Helena’s girlhood benefited her as well. Before the family’s reversal of fortune, the young Helena grew up “free [and] unrestrained,” easily eluding her simple great-aunt Teresa, the adult designated to care for her and Józia, and straying from home to indulge her dreamy imagination."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" That freedom to wander meant that Helena did not know the cloistered girlhood enforced on Kraków’s other middle-class daughters. Maria "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("Estreicherówna attests that a well-brought-up girl “was not allowed to go anywhere without at least a servant in attendance.” A solitary walk to morning mass might have excited gossip. Serious reading or intellectual discussion also was forbidden, for well-bred young ladies were never to pose as “bluestockings.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Helena early sampled the “improper” joys of unchaperoned life.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She also absorbed the extra duties of coping with a large, impoverished household, filling in for absent servants. In the first known letter of her correspondence, she itemized for her brother Szymon the tasks and pursuits of her too busy nineteen-year-old life. Helena sewed and ironed because “only old Kazimierzowa comes twice a day to wash the dishes,” tended her now bedridden Aunt Teresa, supervised her niece Stasia who obeyed her because she “speaks to her as an adult,” and read avidly until three in the morning."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Her independence, workload, and intellectual appetite exceeded what a good Kraków girl of her class was to do and to want, but for the most part her busy mother did not disapprove.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modjeska credits her father, Micha"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v(" Opid, “a student of philology and a teacher in one of the high schools in Cracow,” as the source of her sensitivity and artistry, the storyteller who introduced his children to the "), _c('em', [_vm._v("Iliad")]), _vm._v(" and the musician whose tender music moved his little daughter to unseemly wails."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" This sentimental paternal portrait figures as the first in her memoirs’ extensive gallery of artistic and intellectual mentors. Intent on cultural imprimatur, the actress-memoirist recollected the right teachers and guides to compensate for the formal schooling and social breeding she lacked."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Unlike her older brothers, Helena had to be satisfied with a Kraków girl’s dilettantish education in a Mrs. Radwa"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ska’s pension, several years with her sister “as day scholars at St. John’s convent,” and whatever additional lessons her mother could afford in French, dance, and music."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("It is not surprising, then, that Modjeska takes pains to depict her “husband” Gustaw Zimajer as the educator her “father” did not live to become. The twenty-five-year-old Zimajer had left his much older wife and settled with the Bendas in 1850, when Helena was ten. Her "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(" excise any reference to his checkered past—his extant marriage, love of card playing, lack of steady work, and probable jail time for a swindling scheme. Rather, she highlights his sober image as the family’s German teacher and the family practice he established of reading aloud in the evenings."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Reading sessions with “Mr. Modjeski” (so named in her memoirs to minimize American readers’ confusion or suspicions) schooled Helena in classic and contemporary European "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("literature, from Shakespeare, Goethe, and Schiller, to Scott, Dickens, and George Sand."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Mr. Modjeski also squired Helena, with her mother’s permission, to good German-language plays performed in the Kraków Theatre, to Schiller’s "), _c('em', [_vm._v("Intrigue and Love")]), _vm._v(" and a German-language version of "), _c('em', [_vm._v("Hamlet")]), _vm._v(" starring a promising young Fritz Devrient in the title role."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Even Mr. Modjeski’s completely fabricated marriage proposal links him with high culture, for it takes place during one of their reading sessions and prompts her to admire him as a suitor equal to the romantic figures in her books: “I answered ‘Yes’ without hesitation, because he had already become as dear to me as my own brothers, and besides, my imagination had adorned him with the attributes of all the possible and impossible heroes I read about in poetry and prose.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Most of the actress’s biographers cast Zimajer as a villain or a mistake, a depiction the star herself initiated once she departed Poland and allowed journalists to exaggerate the age difference and antipathy between them. Some accounts declared him old enough to be her grandfather; others prematurely reported his death rather than admit their separation."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn32"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Polish theater scholars are intrigued by Zimajer as her shady first impresario, a philanderer and a sponger who nonetheless singled her out when she might otherwise have been lost in caring for her large, needy family. They note his interesting track record as a midwife of talent, pointing to his second discovery of the singer Adolfina Wodecka after Modrzejewska had left him. The death of Zimajer’s first wife freed him to marry the much younger Wodecka and groom her as the singing star Zimajerowa. Zimajer’s greatest flaw, in these scholars’ estimation, was not his seduction or economic exploitation of Helena, but his inadequate management of her career. He made the wrong decisions for a genius who would soon make all the right ones. Terlecki insists that, after her problematic beginning with Zimajer, Modrzejewska “took her fate into her own hands. Forever after she will shape that fate in sharp contrast to what had gone before—with her moral instinct, will, imagination, and aesthetic sense. She will erase the traces of this period until the very end, until the moment of writing her autobiography-romance, her biographical poem about herself.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn33"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("At that “moment of writing her autobiography-romance” Modjeska carefully polishes Zimajer’s image as she inserts him in "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(". She neither acknowledges his impropriety nor tarnishes his character. Rather than portray her relationship with him in the black-and-white terms laid out by Terlecki, as the period of her fall or uncharacteristic passivity, Modjeska claims Zimajer’s key role in her professional formation and her maintenance "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("of a new star persona. To a considerable extent, his influence and design were consonant with the large patterns that defined and supported her career. She rewrites him quite shrewdly: Zimajer is cast much more effectively as teacher than villain in her story.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The education Modjeska details receiving from Zimajer proved critical to her high-culture ambition. The higher courses for women, the rough equivalent of university instruction, were not instituted in Kraków until 1870."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" In an era when for most actors voracious reading had to substitute for a higher education and good actors were expected to familiarize themselves somehow with the classics of dramatic literature, Helena’s extensive reading sessions with Zimajer helped to guarantee her intellectuality and to elevate her passion for the theater through her sequential cult of the classics."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn35"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Beginning with her beloved pantheon of Polish Romantic poets, Modjeska remembers progressing to Schiller, whose little statuette she literally worshiped, and conclusively to Shakespeare, who “became my master then and there, and remained so through my theatrical career.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn36"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" With Zimajer’s critical guidance, Modjeska thus laid the foundation of her lifelong, career-enhancing literary education.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Helena’s professional debut under Zimajer’s management also entailed her first successful act of reinvention, as she and her lover assumed new public identities. For the duration of their relationship, Helena and Gustaw appeared before the public outside of Kraków and in theater reviews as the presumably married Modrzejewskis. Contrary to rumors about Gustaw selling Helena’s favors to wealthy patrons, the couple preserved the semblance of a respectable, legitimate family until Helena abandoned him. In a letter to her mother during their early days of touring, when she might have dropped the facade, Helena referred to Zimajer as her husband, listed her two children’s surname as the double-barreled “Sinnmayer-Modrzejewski,” and boasted how well she and Gustaw together managed her career: “all this [her rivalry with other actresses] doesn’t rattle me because Gustaw wrangles with everyone, and I am ever polite and politic.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn37"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" It is worth noting that Modjeska would project a similar division of labor between the serene lady artist and her scrappy spouse-manager when her husband Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski managed her American tours.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As her brother’s friend and the household’s live-in teacher, Zimajer also qualified as a member of the theater-crazy family which fundamentally influenced Modjeska’s career and professional identity. For her to claim that Zimajer was “as dear to me as my own brothers” was high praise indeed, as well as "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("strategic placement. Like many other actresses, Modjeska was drawn to the theater through her family members in the business, a connection that lessened somewhat the social stigma of working alongside strange men and displaying oneself before the public. Of the great theater families which emerged in Kraków and throughout partitioned Poland, the extended Benda clan became one of the largest and most renowned. One theater historian estimates that Feliks Benda was related to as many as seventeen actors by blood or marriage."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn38"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When Helena was still a child steeped in daydreams and given to wandering, she caught the theater bug from her lively older brothers: Józef, who hared off on various provincial tours; Szymon, who trained as a musician and conducted theater orchestras; and, above all, Feliks, who began his career as a super in the Kraków Theatre in 1852 and worked his way up to leading man and highlighted character roles."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn39"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Zimajer’s talents in management and production lay behind the scenes, although he filled in onstage as needed and fit easily into the Bendas’ crew. He encouraged the dreams and cultivated the talents of the beautiful sister for whom the career-distracted Józef, Szymon, and Feliks could spare little time. Her brothers seemed to accept Zimajer’s dalliance with Helena as a matter of course and then supported their professional marriage as a going concern.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In general, the energies of the Benda children revolved feverishly around matters theatrical. They mounted the sort of amateur at-home productions that were gaining popularity throughout Kraków, theatricals and tableaux vivants showcased first among the city’s aristocratic families and then emulated by the middle class."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn40"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Helena experienced her older brothers’ at-home plays as a spectator, “since girls were not admitted to this histrionic circle,” but after Józef, Szymon, and Feliks had ventured out into the world, she and her younger siblings staged their very own melodrama, with Helena starring as an “aristocratic Grecian lady” anxiously awaiting the return of her patriot lover."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn41"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Once Feliks had established himself in the Kraków Theatre across town, Helena came into regular contact with theater professionals, and her aspirations grew more specific. She made the acquaintance of her future rival, the young actress Antonina Hoffmann; obsessively sketched the beautiful costumes of Feliks’s leading lady, a Mrs. R. H.; and auditioned (unsuccessfully) before this leading lady with her brother’s encouragement."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn42"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" In the years to come, the brothers and sisters Benda, under different real and stage names, would perform together in different configurations, and Modrzejewska would "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("come to rely on the shielding support and good working relations of a strong family team. Their irregular family circle, inclusive of Zimajer and tacitly endorsed by the pragmatic Józefa, seemed perfectly suited to the stage.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("THE THEATRE OF KRAKÓW")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Beyond Helena’s family circle lay the formative contexts of her hometown—its cultural institutions, historic sights, public spectacles, and political trials. With Zimajer as mentor and Feliks established in its troupe, the young Helena attended the Kraków Theatre located on Szczepa"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski Square and endured performances in its deteriorating, dark, barely heated building. Although gas lighting had been laid on in Kraków in 1857, and locals gathered in late December to view the glorious illumination of the market square, the Kraków Theatre could not yet afford its installation."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn43"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" When the theater’s furnaces broke down, they were not repaired, and the players had to perform bundled in their coats; the local newspaper "), _c('em', [_vm._v("Time")]), _vm._v(" ("), _c('em', [_vm._v("Czas")]), _vm._v(") observed that “even the prima donnas had to sing in their sheepskins.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn44"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" The actor Józef "), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/sa.jpg",
      "width": "8"
    }
  }), _vm._v("liwicki cited similar problems with the heating almost thirty years later, remembering how he slid on an ice-covered floorboard when he ran onstage for his cue."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn45"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The shabby Kraków Theatre was also a theater divided in Helena’s youth. As part of their Germanization program, the Austrian authorities subsidized the operation of a German-language theater on its premises from 1853 to 1860, limiting the Polish company’s performances to twice a week and every other Sunday."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn46"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" The German theater’s various directors tried out a wide range of productions in hopes of attracting audiences in this small, largely Polish-speaking city, including star-studded operas, such sensational acts as the Spanish dancer Pepita de Oliva, and selected Shakespeare plays ("), _c('em', [_vm._v("Othello, Merchant of Venice")]), _vm._v(") featuring the famous African American performer Ira Aldridge."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn47"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" But despite its special privileges and dizzying repertoire, this rather benign Germanizing enterprise faded away, for Krakovians, led by their local aristocrats, preferred Polish-language productions.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Helena was such an avid young theatergoer that she disregarded these discomforts and tensions. Her love of art overcame cold, darkness, and national antipathy. Regardless of the bill, she professed enchantment with the performance and a consequent obsession with replaying or rereading the script on her own. Notwithstanding her patriotism, she “thought better of the Germans” after seeing Schiller onstage."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn48"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Without yet knowing Shakespeare, she sensed in Fritz Devrient’s Hamlet a characterization of such dignity and naturalness that it informed her later understanding of the Bard."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn49"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" By the time Helena was nineteen, Zimajer was encouraging her to train as a German actress, and she found the prospect tantalizing enough to study German-language plays with the help of a fine actor from the German troupe, Blum Axtman. Her perception of art as a value transcending national antagonisms was reinforced by Axtman’s artistic nature, “full of pride, recklessness, and abnegation”; although he fainted from hunger, the German refused any payment for his teaching."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn50"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/28.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Old Kraków Theatre viewed from Szczepa"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski Square. Courtesy of the Kraków City History Museum")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-2"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("It has become commonplace for Modjeska’s biographers to trace her artistry to the city of Kraków and to read her as its product."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn51"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" In paying tribute to the city, they take their cue from Modjeska herself, who could never resist touting the glories of Poland to non-Polish audiences. Yet in "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(" she consistently superimposes the image of a late nineteenth-century Kraków, a lovely city of refurbished monuments, on the dirty, ravaged Kraków of her youth."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn52"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" As she declares the formative influence of her hometown, she rewrites it to be beautiful:")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("This is really Cracow—my cradle, my nurse, my mentor and master. Here I was born and bred. Here trees and stars taught me to think. From the green meadows with their wild flowers I took lessons of harmony in color, the nightingales with their longing songs made me dream of love and beauty. The famous “Zygmunt” bell of the cathedral, with its deep and rich sound, reminded me of the glorious past of Poland; the organs in the churches spoke of God and His Angels; stained windows, statues, and altars suggested art—its importance, its dignity."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn53"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_vm._v("Modjeska carefully recreates her first Kraków as a paradise in which she exists as its gifted interpreter, equipped to reimagine its historic sights and events. Subsequent scenes of her childhood city bask in this paradisiacal glow, featuring only splendid historic buildings and enlivened by quaint religious and seasonal pageantry. Modjeska portrays such citywide celebrations as the Corpus Christi procession, when villagers decked out in their best transformed the city square into a living museum of folk costumes, or the St. John’s Eve “wianki” ceremony, during which unmarried girls cast wreaths of flowers on the Vistula River to foretell their future."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn54"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" The actress refines the visual and atmospheric worth of her rundown hometown much as she refined the intellectual worth of her mentor-seducer Zimajer. Perhaps an ugly Kraków was as inadmissable a fact as extramarital sex. In this case Modjeska demonstrates how she developed herself into an artist by divining the city’s allure and transforming its art into her own. Kraków, she asserts, furnished her a series of training sets and visual cues.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Her memoirs detail how the look and mood of Kraków’s landmarks led her instinctually to pose, to feel, and to "), _c('em', [_vm._v("act")]), _vm._v(". She was well aware of the instrument at her disposal. At home, Helena had taken stock of herself by examining her poses in silhouette: “I had great difficulty managing my arms, and I did not like the appearance of my rather short-fingered hands; they did not look a bit like those I saw in pictures and statues.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn55"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" In the Dominican church located a block from her home, she delighted in mimicking the shape of its Gothic structure, what she supposed was meant to be “two hands joined for prayer, with the finger-tips meeting and relaxed above the wrists, as in some "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("of the pictures of praying Madonnas.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn56"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" On warm summer days she would steal into the cool church for more make-believe: “How often I would lie down, with my face to the ground, in imitation of our peasant women, with arms outstretched in the shape of a cross, kissing the floor, and praying fervently to God for a miracle, for a glimpse of an angel or of some saint.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn57"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Modjeska also extols the long-term theatrical value of her childhood haunts, remembering, for example, how she prepared for Juliet’s scene in the Capulets’ tomb by recalling images of the sinister Franciscan church visible from her window, with its reputedly haunted vaults and “two huge century-old owls” that walked the moonlit grounds."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn58"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" In striking poses and sensing sets, the young Helena demonstrated the prerequisite painterly sensibility with which nineteenth-century actors were to create their characters."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn59"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modjeska’s evocation of her childhood Kraków also links her growth as an actress with her indoctrination as a patriotic Polish woman. She recounts her family’s ordeal during the 1848 Austrian bombardment of the rebellious city, a quick course in maturation as their home was shelled and strafed, the dead lay just outside their windows, and her mother sternly ordered her brother Józef, a member of the Polish National Guard, back into the fray (after angrily agreeing to give shelter to the actress on his arm)."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn60"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" Helena learned similar lessons in resisting the occupier from well-bred young ladies. She recalls a Miss Apollonia, “our young neighbor from the third floor,” who “recited patriotic verses or sang sentimental love-songs,” and taught the young Helena “that all Russians, and Austrians in particular, were scoundrels and cowards who deserved to be hanged one after another until none of them were left on earth.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn61"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" When Helena attended Mrs. Radwa"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ska’s pension, she looked on, fascinated, as her teacher Miss Salomea communicated in code with a political prisoner in a “provisory jail” opposite their apartment. Helena promised never to betray Miss Salomea’s important secret, and consequently wrote “I hate the Austrians” several times in her grammar workbook."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn62"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("According to contemporary observers, the stalwart patriotism of Józefa Bendowa and Misses Apollonia and Salomea was not exceptional. Austrian political repression in the 1850s made poignant martyrs of such Krakovians as Prince Adam Potocki, a popular member of one of Kraków’s first families, and Anna Ro"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/szdot.jpg",
      "width": "7"
    }
  }), _vm._v("ycka, the daughter of a well-known local doctor. Potocki spent a year in jail before being pardoned by the Austrian emperor and released, but Ro"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/szdot.jpg",
      "width": "7"
    }
  }), _vm._v("ycka, sentenced for possession of “forbidden books and national poetry,” died in Austria’s Theresienstadt prison four years after her arrest and despite "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("the protests of her doctors. Her fellow prisoners there admired “her constancy and unbending nature.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn63"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Many upper-and middle-class Krakovians subsequently supported the January 1863 uprising against the authorities in the Russian partition. Both well-bred ladies and popular actresses contributed to the cause as best they could. Maria Kietli"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ska was not bold enough to join women attending forbidden meetings and visiting political prisoners incarcerated in Kraków’s Wawel Castle, but she donated linen for the rebels. The Kraków actress Maria Safir’s much more daring feat involved disguising an imprisoned insurgent in her dress and taking his place in his cell."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn64"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Elsewhere in the Austrian partition, the actress Aniela Aszpergerowa, an accomplished performer who mentored Helena on the Lwów stage, was sentenced to prison for her ties with the uprising, though she was quickly released."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn65"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As local history indicates and her memoirs attest, Helena was raised on such examples of fiery Polish patriotism and saw that women could be outspoken and, to a certain extent, active in their national zeal."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn66"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" The political traumas of her childhood Kraków acquainted her well with real acts of heroism and sacrifice. Like other Poles of her inter-uprising generation, Helena embraced the somber patriotic ideal of the soldier-rebel and a program of conspiracy and revolt in aspiration, if not in fact."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn67"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" More self-styled was her connection of this brand of patriotism with her profession. In "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(" she represents acting as the best, if still inadequate, surrogate for running off to fight: “Alas! it was not my destiny to die for my country, as was my cherished dream, but instead of becoming a heroine, I had to be satisfied with acting heroines, exchanging the armor for tinsel, and the weapon for words.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn68"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Throughout the nineteenth century, Polish actors were admired for their signal public service to an occupied nation by preserving onstage the Polish language, Polish subjects, Polish costumes, even Polish mazurkas. But perhaps no period so theatricalized Polish politics as the early 1860s, when Modrzejewska was launching her career. Beginning with demonstrations to mourn Warsaw victims of Russian oppression in 1861, Krakovians repeatedly mounted public protests “in an atmosphere of excitement and exaltation,” taking solemnly to the streets dressed in "), _c('em', [_vm._v("czamaras")]), _vm._v(" (traditional Polish coats), "), _c('em', [_vm._v("konfederatki")]), _vm._v(" (four-cornered caps), and the black of national mourning. Any woman venturing out in a bright dress was harassed and shamed. These black-garbed citizens gathered in churches for special masses, walked in religious-patriotic processions, and sang Polish hymns and national songs."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn69"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Modjeska "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("recalls how “black crowds knelt down in the Rynek before the picture of the Virgin; and the National Hymn, in accents of desperate complaint, was rising slowly up to heaven.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn70"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In this period, Helena experienced firsthand how theater both informed and bolstered national politics. While she was engaged at the Lwów Theater in the early months of the 1863 uprising, her company deliberately performed “a Polish melodrama, with national costumes and songs” to a house packed with young insurgents. The actors used the device of improvised couplets to convey their support to the soldiers and, as Modjeska writes, “there was such a bond of sympathy between the audience and the stage that were it not for the footlights, they would have all joined in one embrace.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn71"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Yet in this turbulent period of unrest and rebellion, the ardently patriotic Helena remained onstage, content with her “tinsel” and “words.” A patriotism of soldierly discipline and dramatic display, reliant on strong men "), _c('em', [_vm._v("and")]), _vm._v(" women, clearly steeled her commitment to acting, but never waylaid her career.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("A YOUNG STAR ON THE ROAD")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In late 1859, Helena informed her brother Szymon that she was to become a German actress and identified “Mr. Gustaw” as the author of this plan."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn72"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Her diary fragments dating from the same period embellished on her fears and fantasies about playing great roles “on the German stage, among strangers,” envisioning herself as “Louise, wringing her hands and shedding tears, Ophelia with her vacant stare, Marguerite in the arms of Faust.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn73"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Zimajer’s reasoning likely stemmed from professional calculation, not nationalist bias (he was a Polonized German), for on the German stage, as Helena parroted, “Mr. Gustaw says I’ll have better prospects.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("By 1861, however, this much-contemplated venture had to be postponed due to Helena’s pregnancy. The first years of her performing career overlapped with her first years of motherhood, as she gave birth in daunting succession to Rudolf on 27 January 1861 and Maria on 10 April 1862. Like so many other actresses, Helena had to navigate the “momentous obstacles” of pregnancy, childbirth, and child care along with the arduous physical and mental demands of touring."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn74"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" That she dared to do so from the outset of her career reflected her ambition and probable desperation. By 1860, her younger sister, Józia, had joined a provincial troupe and was already touring under the stage name Kossowska."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn75"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("For the most part, Helena managed both young children and new career remarkably well, aided by a Benda family used to accommodating irregular relations and their offspring. When Helena, Gustaw, and the newborn Rudolf embarked for the tiny town of Bochnia, where they found refuge with Józefa’s relatives, Józefa and Helena’s niece Stasia accompanied them."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn76"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" Helena also mentioned a hired nanny when she wrote Józefa from Lwów in 1862. Although Helena’s daughter lived only a few years, her death was probably caused by an accident, not family neglect."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn77"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" The actress’s letters indicate that she was a loving, proud, and quite controlling mother who boasted about her surviving child’s accomplishments and assiduously, if somewhat imperiously, arranged his affairs. Helena walked firmly in Józefa’s matriarchal footsteps.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The aspiring young actress also was determined that motherhood not deter her from pursuing her dreams, even if their initial settings proved more rustic than she had anticipated. During these early touring years, Modrzejewska first demonstrated her legendary iron will and workaholic habits. The birth of her daughter served as a remarkable case in point. The director of her troupe at that time, Konstanty "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("obojko, remembered that Madame Modrzejewska “began to give birth before the last act [of the drama "), _c('em', [_vm._v("Polish Homes")]), _vm._v("], yet managed to finish the performance. Afterwards we took her home, supporting her on either side, and an hour later little Maria came into the world.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn78"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" In ten days, the new mother resumed her place on the stage, for by this time she had become “a favorite of our provincial public” and the dependable star attraction of her troupe."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn79"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Like most Polish actors in the nineteenth century, Helena Modrzejewska was born on the road. Provincial touring constituted either a preparatory stage or a lifelong career for virtually every Polish player, despite its physical hardships, great financial uncertainty, and bureaucratic hassles, especially when troupes toured across partitions."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn80"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" Only a small minority landed engagements in one of Poland’s permanent theaters—the Kraków Theatre, the Lwów Theatre, and the best-paying, government-subsidized Warsaw Imperial Theatres. For most troupes, touring was an arduous business entailing travel from town to town on cart or by foot, substandard food and lodging, and improvised stages in taverns or barns where towns had no appropriate hall."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn81"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" Directly dependent on each night’s proceeds, touring troupes usually tailored their repertoire to the presumed tastes of the locals, which meant relying on light comedy or more sensational entertainments."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn82"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Touring players could not always be certain of the locals’ welcome. While they might be accepted "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("as artists and respected as valiant bearers of Polish culture, they might just as readily be disdained as poor tramps and loose women."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn83"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("From her summer 1861 debut in Bochnia to her engagement with the Kraków Theatre in fall 1865, Modrzejewska’s progress described not a steady ascent, but the small leaps forward and occasional setbacks typical for even a talented actor on provincial tour. During these four years, she toured Galician towns of varying sizes and box office prospects; performed for a short time under contract in the great theater in Lwów; made an unsuccessful debut in Vienna; and played in and around Czerniowce, the provincial capital of Bukowina, a small city of 30,000 populated by Poles, Germans, Moldavians, Jews, Armenians, and Rusyns."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn84"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" To be fair to her manager-husband, Zimajer strived to advance his protégée’s career according to the tried-and-true patterns of the day. An engagement with a permanent theater enabled Polish actors to move up the professional ladder or to bargain for better positions elsewhere. When Zimajer arranged for Modrzejewska’s debut in Vienna, trying at last to deliver on his promise of German stardom, he was following the tantalizing lead of successful crossover players. The great Bogumi"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v(" Dawison (1818–1872), whose American tour preceded Modrzejewska’s San Francisco debut by a little over a decade, brilliantly exemplified a Polish actor’s possibilities on the German-language stage, as his performances won accolades in Vienna, Dresden, Berlin, and Munich."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn85"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Yet the touring life, especially for a novice, could be exhilarating, especially when it signified a more intense version of the sort of work that Modrzejewska coveted at home. Launching a career in tiny Bochnia might have seemed an exercise in futility. Instead, she carefully remembers the experience as the backstory of putting on a hit show. Modjeska describes how she and Mr. Modjeski chance upon their Kraków acquaintance, the photographer, dance instructor, and sometime actor Konstanty "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("obojko, as they are strolling around town, and the three soon dream up a troupe which they eventually formalize as “The Nowy S"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/a.jpg",
      "width": "9"
    }
  }), _vm._v("cz Company of National Artists.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modjeska represents the troupe’s founding as serendipitous, prompted by their desire to hold a benefit for the widows and children of local workers who had perished in a mining accident. Her account of how avidly they hunt for repertoire, rent a hall, paint scenery, and post bills betrays their long-term plans. The company’s tiny cast was something of a Benda family production, including Helena, "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("obojko, "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("obojko’s dance pupil Mr. Baumann, Helena’s sister Józia (stage name Kossowska), and her niece Stasia as prompter, with "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("Helena debuting as Modrzejewska, and Zimajer, by default and in solidarity, as Modrzejewski. Their benefit, featuring the light one-act comedy "), _c('em', [_vm._v("White Camellia")]), _vm._v(" and the two-act “play with songs” titled "), _c('em', [_vm._v("Prima Donna, or the Foster Sister")]), _vm._v(", immediately extended into a series of performances with changing repertoire played to consistently good houses. In short order, Modjeska reports receiving authoritative confirmation of her talent, when Jan Ch"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("cinski, a Warsaw actor visiting the area and her future director on the Warsaw stage, complimented her after one performance and expressed the hope that he would see her soon in his city. Hollywood could not have scripted a more upbeat amateur-to-professional success story than the debut Modjeska retells in "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn86"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Once their Bochnia performances had made them a going concern, "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("obo jko’s troupe began touring in earnest. With Zimajer as their “de facto … business head,” they traveled in a wagon resembling an American prairie schooner to perform, among other places, in the mountain town of Nowy S"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/a.jpg",
      "width": "9"
    }
  }), _vm._v("cz, from which they took their name; the larger town of Rzeszów, where they drew good audiences for three months; Sambor, where Maria (Sinnmayer-Modrzejewska) was born; Brzezany, where Józia married fellow troupe actor Walery Tomaszewicz; and Brody, where, in "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("obojko’s terse account, a fire destroyed one hundred twenty homes, performances had to be cancelled for ten days, the actors received only half pay, and “Madame Modrzejewska left for Lwów with her husband and son.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn87"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Over this first touring year, their company swelled to thirty-six players, recruited at last a proficient artistic director and leading man in Lucjan Orty"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski, and won favorable reviews in the prominent Lwów newspaper the "), _c('em', [_vm._v("Literary Daily")]), _vm._v(" ("), _c('em', [_vm._v("Dziennik literacki")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modrzejewska’s initial experience on the road was quite successful, all things considered, and it spotlighted her from the outset as her troupe’s beautiful, talented star. Despite its hardships and limited circulation, provincial touring could launch good actors on a fast track to better roles and star status, in contrast to permanent theaters where a novice confronted an entrenched company and fiercer competition."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn88"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" As early as November 1861, the "), _c('em', [_vm._v("Literary Daily")]), _vm._v("’s correspondent remarked the improvement of "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("obojko’s troupe under Orty"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski’s direction and singled out Modrzejewska as an actress of “undeniable talent, with the potential of becoming an ornament on our greatest stage if she keeps up the good work.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn89"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" The reviewer for the "), _c('em', [_vm._v("Literary Daily")]), _vm._v(" repeatedly praised the experienced Orty"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski and the novice Modrzejewska. A 2 May 1862 review offered this characteristic assessment, heralding her as “ornament” once again: “Young, pretty, talented, filled with a love of art and possessed of a singing, resonant, sweet voice, she deserves a brilliant future.… With conscientious work and zealous exercise, Modrzejewska may become a valuable ornament not only in her current company, but in any other troupe.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn90"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/36.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("Gustaw Zimajer and Helena Modrzejewska around 1863. Photo by W. Beldowicz. Courtesy of the Warsaw Theatre Museum")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The "), _c('em', [_vm._v("Literary Daily")]), _vm._v(" review sounded what would become a recurring refrain in Modrzejewska’s clippings—an automatic registering of her beauty and charm. In an era when poor lighting and small stages led audiences and critics to value large, clear features and expressive faces, Modrzejewska presented an almost ideal physical specimen."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn91"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" Early photographs of the actress posed in stage roles capture her strikingly well-proportioned face and body—her large lovely eyes, strong profile, graceful and vivid expression, and statuesque figure. As theater historian Dariusz Kosi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski observes, conceptions of beauty in the nineteenth-century Polish theater prescribed a blend of the "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("real with the ideal, and Modrzejewska incarnated this blend with the givens of face and figure and her growing mastery of “rounded,” often balletic gestures and gait."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn92"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" Her innate charm, provided she used it in an artistic and not coquettishly personal manner, was also a highly desirable attribute."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn93"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" Modrzejewska’s “resonant, sweet” voice proved too limited initially to be ideal, but for much of her career she worked to improve its strength, range, and durability."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn94"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" The sum impact of Modrzejewska’s magnificent parts almost invariably wowed audiences and critics, beginning with her first year on tour and for decades to come.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This gorgeous, charming, inherently talented young actress thrilled to the road. When Modjeska recalls how simply she needed to live and how intensively she had to work during her first year on tour, her memoir account is suffused with happiness. As Dobrochna Ratajczak observes, Modjeska depicts her travels from Bochnia to Nowy S"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/a.jpg",
      "width": "9"
    }
  }), _vm._v("cz, the initial leg of her tour, as entry into a provincial arcadia peopled with merry, singing peasants and laid out with “luxuriant orchards, golden fields, … diminutive white huts,” and the Carpathian Mountains in the distance."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn95"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" In her memoirs and letters, Modjeska regularly professes her delight in nature, unveiling, to be sure, her Romantic artist’s soul, but also demonstrating the sensibility of an educated tourist. On the road to Nowy S"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/a.jpg",
      "width": "9"
    }
  }), _vm._v("cz, she was at once a poor wandering player and, in retrospect before her readers, a traveler relishing natural wonders and the colorful folk."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn96"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-2"
  }, [_vm._v("Modrzejewska took up her workload with equal fervor. No passage in "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(" better conveys her joy in her profession:")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("Work was a delight to me. Even now when I think of my enthusiasm of those days, I am thrilled with the recollection. We lived in rooms which were barely furnished. We had to sit on boxes and all sorts of improvised seats. I had but two dresses, one black and the other white, with two tunics, which I used to transform by addition of black and pink ruches; our meals were frugal, but I could see from the porch fields of wild flowers, trees, and mountains; above all, I had my parts, walking up and down on the veranda, I studied them, to the accompaniment of the birds’ songs, and I felt as proud and wealthy as the richest woman. To live in the imaginary world of my heroines, to speak their poetic language, to render different sentiments, to work out a character, were the most cherished delights of my existence."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn97"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_vm._v("Apart from the idyllic natural setting of her workplace, most important in this passage is Modjeska’s emphasis on intensive self-training—her pure dedication to studying and memorizing parts and working out a character. Just as she implies her innate actor’s response to Krakow’s suggestive settings, so her memories of early touring, before she could be influenced by the great actors "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("and impresarios of the Polish theater, highlight a self-development that anticipates some of the major practices other actors would need to be taught. In "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(" the young Modrzejewska has learned to be “dead-letter perfect” in committing her parts to memory; to perform a wide array of roles, despite the fact that she “was the star from the beginning”; and to rehearse roles in costume so as to play them naturally onstage."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn98"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" She seems to intuit a widely prescribed technique for developing a character “from the whole to its parts” ("), _c('em', [_vm._v("od ogo"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("u do szczego"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("u")]), _vm._v("): “When I could not see the vision in my mind from head to foot, even to the garment and the gestures, when I could not hear my own voice ringing in the accents of my vision, I rejected the part, for I knew I could not play it to my satisfaction.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn99"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Nevertheless, as her critics underscored, Modrzejewska needed more rigorous, formal training to fulfill her potential as “ornament” on a greater stage. Her explorations of first the Lwów Theatre and then Vienna’s theaters, facilitated by Zimajer, took reasonable steps toward this goal, although neither experience advanced her very far. The Lwów Theatre offered her an impressive physical venue. Its imposing new building, lavishly funded by Count Stanis"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aw Skarbek and opened in 1842, was shaped like an amphitheater and boasted seating for 1,460 patrons, the latest in stage sets and machinery, and a magnificent Demuth chandelier from Vienna."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn100"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" The reviews of Modrzejewska’s three audition plays indicated that Count Skarbek’s theater could provide her with the necessary training as well. One well-wishing reviewer attributed her uneven performances to a lack of “deeper character study” and, by extension, the limitations of her “first school” of playing in the provinces. Recommending her engagement, he argued that her innate talent could be properly developed by “intelligent direction” and the “excellent role model” of Lwów’s veteran actress, Madame Aniela Aszpergerowa."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn101"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("For her part, Modrzejewska was feeling feisty at the outset of her Lwów engagement. In her aforementioned 9 November 1862 letter to her mother, in which she praised Zimajer’s negotiation of her contract (she was hired as a "), _c('em', [_vm._v("wodewilistka")]), _vm._v(", vaudeville player), she declared that she was ready to compete with the younger Lwów actresses who envied her good reviews and wished her ill. Even from the lofty distance of her memoirs, she chose to denounce the dirty tricks played on her by these three identified “antagonistic goddesses,” Teofila Nowakowska, Paulina Targowska, and Józefa Radzy"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ska Hubertowa (the Mrs. R. H. who had pronounced Helena talentless in Kraków)."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn102"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" Another letter sent in late 1862 to her half-brother Adolf read like a battle plan, "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("taking broader aim at the Lwów company and revealing just how cocky and calculating the provincial star Modrzejewska had become: “As you know, I’m under contract in Lwów, and Madame Aszpergerowa is truly a great role model. I’m trying to learn all I can from her performances, and it seems to me that I can reach her pinnacle of fame with little trouble. A little more work, and I’ll make it. Right now I’m mainly cast in vaudeville parts. Misses Targowska and Nowakowska won’t let me near real dramas, but I’ll prevail.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn103"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As it turned out, Modrzejewska lacked both the position and protection to displace her entrenched young rivals in Lwów. She opted not to serve out her contract, for her pay was too low, the work and expense too much (like most actresses, she had to make her own costumes), and the roles left her after the evil trio had taken their pick were the too small parts of “pages, gypsies, servant-girls, peasant women, mysterious countesses in French melodramas.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn104"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" The “intelligent direction” recommended for her progress never materialized. Modjeska hinted that the Lwów Theatre’s “fatherly managers” were pledged to obey the “goddesses.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn105"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Yet Modrzejewska did discover two useful role models among Lwów’s actresses. Although she sized up the “excellent” Aszpergerowa as a benchmark, she also appreciated the older actress’s encouragement and coaching on parts, lines, and costumes. She learned the value of collaboration even as she competed. Five years later, when she had achieved Aszpergerowa’s pinnacle of fame, Modrzejewska helped arrange for the Lwów actress’s guest appearances in the Kraków Theatre."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn106"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" In Lwów, Modrzejewska also made the passing acquaintance of the young actress Maria "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("agowska (stage name Marie Vergne Fontelive), whom she had been hired in part to replace."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn107"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" The friendly Fontelive was already bound for Vienna’s Carlstheater, literally enacting Helena’s master plan and enduring negative press coverage for her defection."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn108"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" When Modrzejewska caught up with Fontelive in Vienna three years later, the now Viennese actress was blazing another life trail, about to marry a handsome prince and leave the stage."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn109"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" These Lwów acquaintances incarnated several standard versions of a Polish actress’s successful future—an enduring stage career in Poland, triumph on a foreign stage, or social ascent into a noble marriage and retirement."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn110"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("During this period of Zimajer-Modrzejewski’s management, the couple also tested Modrzejewska’s viability on the German-language stage by taking a vacation in Vienna in 1865 and sampling its cultural sights. Once again, Modrzejewska, albeit with Zimajer’s assistance, had anticipated a professional "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("practice subsequently recommended to other actors, going abroad to study the great performers of Vienna, Berlin, Paris, and London. After her informal audition with an unnamed Viennese theater manager, she was advised to study German one more year; the Modrzejewskis could not afford the delay. But their vacation, her first visit to a European capital, exposed her to grander art and consequently grander possibilities. A tour of the great paintings in Vienna’s Luxembourg Galleries amplified Modrzejewska’s ambition and resolve: “I felt small and humble in the presence of the masterpieces of all ages and all nations, and yet, underneath this humility, I felt a glow of superhuman strength, and a hope that one day I might achieve fame,—in a different and smaller way, of course—for our art was scarcely considered an art at all, but I formed then a strong determination never to rest until I had climbed to the very top of my profession.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn111"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Between Modrzejewska’s temporary defeat in Lwów and her horizon-expanding trip to Vienna, she and Zimajer returned to provincial touring, even as the January 1863 uprising caught fire around them. By April, they had played their way to Czerniowce, a small city in the southeastern corner of Galicia, where they more or less remained for the next two years."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn112"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" To some extent this move must have seemed a setback to the young actress, a regression to touring’s financial uncertainties and fluid companies. With its mixed ethnic population, Czerniowce could not sustain a year-round Polish theater, and anyone mounting a theatrical enterprise there had to include German-language productions to stay afloat. When the Modrzejewskis arrived, their former co-star Lucjan Orty"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski headed up the local Polish troupe, but opted to direct the German troupe by year’s end. Once Zimajer had obtained the concession to establish a troupe by mid-1864, his company was expressly Polish-German. Even so, the Polish actors had to resort to local touring outside of the city to survive.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modrzejewska’s next logical step would have been to perform in German, as Zimajer had planned in Kraków, but she did not do so here or anywhere else. She may have hesitated on patriotic grounds. In her memoirs, she fashions a little melodrama around the German-language debut that Zimajer has prepared for her in Czerniowce. Her apprehension of betraying her country provoked convulsive sobs and a convenient fainting spell, which resulted in the performance’s cancellation. She may have balked for more complicated personal reasons. At this point in her memoirs she refers to “Mr. Modjeski” more distantly as the man “she dared not disappoint.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn113"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("Yet these uncertain two years, when Modrzejewska was sensing the limits of Zimajer’s managerial abilities, also renewed her confidence in her star quality, provided her diverse opportunities for professional growth, and reunited her with the still supportive network of her family. In the variously made-up Polish troupes in Czerniowce, Modrzejewska once more reigned as the star, as her reviews in the German-language newspaper "), _c('em', [_vm._v("Bukowina")]), _vm._v(" attest."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn114"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" The ambitious repertoire that Orty"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski assayed and the troupe continued to perform after his departure allowed her to try out serious and even tragic leading roles for which she was eager, if not professionally prepared."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn115"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" As she notes in "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(", in Czerniowce she spent an hour or two each day exercising her voice to achieve the deeper shading of a tragedienne."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn116"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" Modrzejewska played such parts as the beautiful wife Amelia who loved another in Polish Romantic writer Juliusz S"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("owacki’s historical drama "), _c('em', [_vm._v("Mazepa;")]), _vm._v(" the eponymous "), _c('em', [_vm._v("Barbara Radziwi"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("ówna")]), _vm._v(" in Alojzy Feli"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski’s play about a tragic Polish princess poisoned by her mother-in-law before she, a commoner, could be crowned queen; and two incarnations of the rebellious Scottish queen Mary Stuart, a sympathetic portrait by Schiller and a far more critical characterization by S"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("owacki.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In Czerniowce, Modrzejewska also found a professional equal, a kind of male double, in the actor Wincenty Rapacki. The two had met while Modrzejewska was on tour in Sambor earlier in 1863, but they began serious work together only in the Bukovina capital. Born in 1840, Rapacki was Modrzejewska’s peer and likewise a driven, highly disciplined self-starter, although he had benefited from more training in both secondary school and Warsaw’s School of Drama. Like Modrzejewska, Rapacki had performed in provincial troupes and had attempted an engagement on the Lwów stage."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn117"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" Equally invested in meticulous role preparation and challenging repertoire, Modrzejewska and Rapacki were paired together and critically acclaimed in such works as S"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("owacki’s "), _c('em', [_vm._v("Mazepa")]), _vm._v(" and Schiller’s "), _c('em', [_vm._v("Maria Stuart")]), _vm._v(", with Modrzejewska playing the sensitive young heroine or tragic queen vis-à-vis Rapacki’s older male leads and strong character roles."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn118"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" Yet even at this early stage in their careers, Rapacki explored professional opportunities rarely accessible to an actress, assuming the direction of the Czerniowce troupe for a very brief stint in 1863 and adapting Victor Hugo’s novel "), _c('em', [_vm._v("Les Miserables")]), _vm._v(" for their stage."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn119"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Over these two years, Modrzejewska’s troupe also came to include all of the actors in her family—Feliks; his wife, Weronika; his adopted daughter, Henryka; Józia and her husband, Walery Tomaszewicz; Józef; and even Szymon, "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("“just returned from the Vienna conservatory” and made the director of their theater orchestra."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn120"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" Modrzejewska’s relations with her clan had grown more complicated, but no less sanguine. She was clearly established as the star of the family, the phenomenon onstage, the family’s best-looking and best natural actor. At the same time, she was still learning and benefiting from her older brothers’ experience and entrepreneurial savvy. In "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(", she details how inventive and aggressive her brother Józef was in improvising stage sets and costumes on the tours outside of Czerniowce. A June 1865 review in the "), _c('em', [_vm._v("Literary Daily")]), _vm._v(" also made a startling disclosure about her brothers’ grand plans. After roundly praising the Bendas’ troupe for its professionalism, fine orchestra, and commendable repertoire (inclusive of Schiller’s "), _c('em', [_vm._v("Robbers")]), _vm._v(" and Nikolai Gogol’s "), _c('em', [_vm._v("Inspector General")]), _vm._v("), the reviewer announced that the brothers’ “main goal and ambition is to direct the Kraków stage.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn121"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The Benda brothers did not realize this ambition, but they succeeded in delivering their star sister to Kraków by fall 1865, where she, Feliks, and Weronika were recruited for the new Kraków Theatre company being formed. How Modrzejewska decided to leave Zimajer in Czerniowce remains a subject of much speculation or blatantly inaccurate report. Her decision broke apart her personal and professional world. It meant dismantling her fictitiously respectable little family and abandoning her carefully constructed star-manager partnership with Zimajer. Yet the Czerniowce theatrical enterprise was clearly floundering, and Modrzejewska now seemed ambivalent about Zimajer’s German-language vision of her brilliant career. More terribly, their little daughter, Maria, had died in the spring of 1865, and Modrzejewska’s grief may have led to a further alienation of affections and a strong need for a change of scene. Her memoirs cloak the crisis in vague terms of injury and illness: “Blow after blow struck my heart and bruised it to the core. Family considerations do not allow me to give the details of all I suffered at that time; but after fearful struggles with inexorable Fate, I found myself free, but ill and at the point of death. My mother and my brother Felix brought me and my little son Rudolphe to Cracow, and I never saw Mr. Modjeski again.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn122"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("At least in the life story she designed for posterity, Modjeska did not kill off her lover or reduce him to a professional mistake. Nor did she admit the harm and embarrassment he inflicted thereafter by holding their son hostage and exciting gossip with his new wife and theatrical discovery. On paper, Modjeska nearly achieved the clean slate that she could never guarantee in life.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("MODRZEJEWSKA IN KRAKÓW")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("As her "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("critics had observed and Modrzejewska herself knew, her acting skills still needed honing when she returned to Kraków after four years on the road."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn123"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" But her relationship to her hometown had changed fundamentally. Modrzejewska was no longer the young Helena who practiced make-believe in Kraków’s settings with a future audience in mind. She returned to Kraków an experienced actress who was engaged immediately by the city’s best theater. During her three extraordinarily successful years there, she was ever a performer on public display in a small city—a professional on the boards and a local celebrity increasingly admired in society. All Kraków now served as her formal stage.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modrzejewska’s reentry in 1865 was fortuitous because Kraków was then on the verge of a municipal renaissance. In the latter half of the 1860s, the once-free city regained a precious national prominence in consequence of the Austrian empire’s new weakness. After Austria lost the Prusso-Austrian War in 1866, the empire yielded to Hungarian demands and was reconstituted as the Austro-Hungarian monarchy. At roughly the same time, the empire negotiated support from the Polish conservative aristocratic faction in its Council of Nations by ceding Galicia local national autonomy."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn124"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" Austrian concessions included reinstating Polish as the official language of the administration, courts, and schools; granting the city of Kraków self-government; re-Polonizing Kraków’s prestigious, historic Jagiellonian University; and establishing Kraków’s Academy of Arts and Letters."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn125"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" The empire’s new tolerance of the circulation, study, and preservation of Polish subjects enabled Kraków’s florescence as the most prominent center of Polish intellectual life after the 1863 uprising. In sharp contrast, Russian-ruled Warsaw suffered terrible political and economic repressions, and its press and theaters had to cope with often eviscerating censorship.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Kraków’s institutional and cultural rejuvenation coincided with the spread of Positivism, a philosophy which abetted its populace’s increasing professionalization and advocated organic foundation work to rebuild the nation’s culture and economy in lieu of planning yet another armed revolt. Once the city regained administrative autonomy, its newly elected mayor, Józef Dietl, a middle-class doctor of a Polonized German family and a former rector of Jagiellonian University, actively promoted cooperation among the city’s classes "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("and borrowed the aristocrats’ grand gestures toward achieving that goal, hosting citywide balls and holiday feasts for the poor."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn126"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" Before Dietl took office, an intelligentsia was emerging from the growing numbers of educated professionals in the city—doctors, bankers, industrialists, scholars—who collaborated with civic-minded aristocrats on various social and cultural ventures.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The reformation of the Kraków Theatre modeled one such enterprise, a product of sanguine class collaboration as well as a kind of pet project of the aristocracy. In summer 1865, a consortium of aristocrats, bankers, and intellectuals—among them, Adam Potocki, Adam Skorupka, and Stanis"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aw Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian—commenced the theater’s reorganization, raising the impressive sum of 15,000 Austrian florins for the task and convincing aristocratic landed gentry and affluent middle-class patrons to demonstrate their patriotism and good taste by buying subscriptions for the 1865–1866 season."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn127"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" The new enterprise was headed by Count Adam Skorupka, a theater lover whose reputation as a “Parisian in Kraków” reflected his extensive familiarity with France and French culture."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn128"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" Some historians judge Skorupka to have been a good front man for the Kraków Theatre, well-positioned to badger his aristocratic peers for support and quick to launch renovations of the theater building’s lighting and heating systems, buy much-needed costumes and decorations in Vienna, and hire staff, including an artistic director."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn129"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" Others dismiss Skorupka as an inexperienced manager and ladies’ man, pointing instead to the long-term influence of Stanis"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aw Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian, an intellectual and aristocrat with a thoroughgoing knowledge of European drama and the Parisian and Viennese stages. Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian assumed artistic direction of the theater in January 1866 and soon after partnered with Skorupka as general director. Before Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian was free to serve, however, Skorupka imported a first artistic director from Warsaw, the retired actor, director, playwright, and teacher Jan Seweryn Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Whatever Skorupka’s flaws as director, the forty-odd-member cast he assembled was by all accounts extraordinary. It included Modrzejewska; Feliks Benda and his wife; Wincenty Rapacki and his wife, the actress Józefina (?) Baumann; and the reigning young star of the Kraków stage, Antonina Hoffmann, a highly talented performer who was Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s lifelong mistress and whose surname discreetly shifted from maiden to married variant (Hoffmanówna to Hoffmannowa or Hoffmann) in theater reviews over the years. That this cast was assembled all at once gave Modrzejewska a key advantage: She faced Hoffmann alone as a rival for female leading roles. While her male romantic partner in these roles was most often the accomplished Warsaw actor "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("W"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("adys"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aw Swieszewski (1827–1876) in her first Kraków season, she later played regularly opposite her brother Feliks.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Just as Modjeska remembered her first impressions of her hometown to be more interactive than absorptive, so the influence of the Kraków Theatre on the young actress, in her assessment, proved far less formative than collaborative. Modrzejewska’s three years in the newly organized theater coincided with the gradual emergence of what theater critics and historians dubbed the “Kraków School” of acting."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn130"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian is usually credited as the Kraków School’s creator, for he not only reigned as artistic director and then formal general director of the theater from 1871 to 1885, but also wrote extensively in the Kraków press about the Kraków Theatre and the theater. Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian served as one of the editors and chief contributors to "), _c('em', [_vm._v("Time")]), _vm._v(" ("), _c('em', [_vm._v("Czas")]), _vm._v("), Kraków’s conservative and most respected daily. He also co-founded and co-edited "), _c('em', [_vm._v("Polish Review")]), _vm._v(" ("), _c('em', [_vm._v("Przegl"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/a.jpg",
      "width": "9"
    }
  }), _vm._v("d Polski")]), _vm._v("), a serious journal on Polish culture and history, and "), _c('em', [_vm._v("Theatre Bill")]), _vm._v(" ("), _c('em', [_vm._v("Afisz Teatralny")]), _vm._v("), a compendium of theater news intended “to link the theater with its public.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn131"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" In general, Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian functioned as a dominant influence in 1860s Kraków, for he was one of the leaders of the Sta"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("czyks, the city’s strong conservative political faction.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As it evolved over the decades of Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s supervision, the Kraków School was perceived as distinctive and innovative in its emphasis on script preparation, character analysis, good diction, strong ensemble work, intensive rehearsing and performance schedules, and an acting style based on truth, simplicity, naturalness, and moderation. In his “Address to Actors” before the opening of the 1871–1872 season, Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian prescribed a repertoire that encompassed, in the following order of importance, classic Polish drama, good contemporary Polish plays, the masterpieces of world drama with Shakespeare at the fore, and the best contemporary works available, which he primarily identified as witty, well-made French plays."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn132"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s influence on the Kraków Theatre’s repertoire was already evident in 1866, his first year as artistic director. The Kraków School’s other features were less clearly authored and less quickly defined, although Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian came to approve these in his reviews over the years and to cultivate them in later generations of actors. The improvement in actors’ diction and the focus on careful ensemble work, for example, had already begun under Jan Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski’s direction in fall 1865."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn133"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" Nor was it always clear if the Kraków School developed through its directors or its actors. As Got remarks in his biography of Antonina Hoffmann, Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s mistress and colleague, the actress “was the "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("living example of the principles articulated by the School’s creator.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn134"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" Theater historian Zbigniew Jab"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("o"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski likewise identifies Hoffmann’s measured performances, stripped of pathos, declamation, and conventional gestures and mimicry, as truly representative of the Kraków School. It would be difficult to ascertain which came first: Hoffmann’s thoughtful acting or Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s thoughtful design.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modrzejewska’s molding by the Kraków School is also debatable, even though she entered Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian and Hoffman’s force field as a mere provincial star. Certainly her rehearsal and performance schedule intensified: combined rehearsals and shows on Tuesdays, Thursdays, and Saturdays; morning and afternoon rehearsals on Mondays, Wednesdays, and Fridays; and performances on Sundays."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn135"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" To satisfy a stable, small-city audience with ever-new fare, the directors mounted frequent premieres—a wearying six per month in spring 1866—and slated six rehearsals to prepare for each one."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn136"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" Noting that “there was but little time for amusement” during her Kraków years, Modjeska also admits the stress of overwork, recalling “the most dreadful experience” of temporary memory loss before one rehearsal because she “studied so much during the season of 1866–67.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn137"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-2"
  }, [_vm._v("Yet with minimal retraining, Modrzejewska impressed the Kraków audience from the moment of her debut. Commenting on her performances in Wac"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aw Szymanowski’s weak historical drama "), _c('em', [_vm._v("Salomon")]), _vm._v(" and the same "), _c('em', [_vm._v("White Camellia")]), _vm._v(" that she had played in distant Bochnia, the reviewer in "), _c('em', [_vm._v("Time")]), _vm._v(" enthused:")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("Modrzejowska ["), _c('em', [_vm._v("sic")]), _vm._v("] presented herself from the start as the kind of artist rarely encountered even in the great capitals, an artist who, with work and excellent direction, could be first-rate. Nature has been very generous to her, giving her all that an artist truly needs—that is, aside from a beautiful exterior, figure, and voice, that most important gift of artistic perceptiveness, a perceptiveness that instinctively senses what a role requires. Mme. Modrzejowska ["), _c('em', [_vm._v("sic")]), _vm._v("] also possesses a delicacy in grasping her role and the sort of charm that even the most assiduous efforts cannot achieve, for this kind of charm is innate."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn138"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_vm._v("In "), _c('em', [_vm._v("Salomon")]), _vm._v(" Modrzejewska played the good Jewish daughter Sara (characterized by the "), _c('em', [_vm._v("Time")]), _vm._v(" reviewer as a “womanly ideal”) who falls in love with both a Polish nobleman and his Christian faith, for which she is killed by her father. Rebutting an overheard remark that Modrzejewska’s characterization seemed not at all Jewish, the reviewer for "), _c('em', [_vm._v("Time")]), _vm._v(" defended her decision to play Sara with queenly serenity and resignation to her fate. Drawing on her generous "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("natural gifts, Modrzejewska apparently endowed a markedly ethnic role with standardized Polish beauty and nobility. Her graceful suffering became the play’s main event. Her performance in the salon comedy "), _c('em', [_vm._v("White Camellia")]), _vm._v(" proved all the more impressive because this “serious and ideal Sara” reincarnated herself as the elegant Countess Hortensia “with such truth and charm.” Here the reviewer combined kudos with an intriguing observation on the actress’s real social status, declaring that no one would know that Modrzejewska’s salon character was being played by “a middle-class girl from Kraków who had never frequented salons and knew no such role models from touring provincial stages.” His comment intimated both the class-jumping power of performance as well as Modrzejewska’s innate nobility, assessments that recurred with the actress’s growing stardom.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This rave review did specify, however, that the inherently gifted Modrzejewska still required “excellent direction” from the Kraków Theatre’s presumably superior management. As theater historian Jan Michalik observes, the little concrete information that exists about rehearsals conducted in the Kraków Theatre pertains chiefly to later years in Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s directorship. By these accounts, an established Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian had his actors read scripts carefully, analyze their characters’ psychology, and attend all rehearsals for a premiere."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn139"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" But it is telling that Modjeska, one of the few actor-memoirists to describe a Kraków Theatre rehearsal, opts not only to highlight the direction of Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s predecessor Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski, but also pronounces Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski, "), _c('em', [_vm._v("not")]), _vm._v(" Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian, “my master” and “the animating spirit of the whole institution, as well as a perfect and accomplished instructor.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn140"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski had been her director for just three months. When he was discreetly relieved of his position in January 1866, the implied reasons included his import of mediocre repertoire from the Warsaw stage as well as assigning the new player Modrzejewska leading roles normally given Hoffmann, who was away from the stage until late in 1865."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn141"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" Several decades later Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian disclosed that “Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski supported [Modrzejewska] to Hoffmann’s detriment, and it was no surprise that [Hoffmann] consequently felt aggrieved.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn142"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modjeska’s version of this story insists that the sixty-year-old Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski kindly took her under his wing, corrected the singsong declamation of verse drama that marked her as a provincial player, praised her diligence despite her easy triumphs as a “"), _c('em', [_vm._v("so-called ‘")]), _vm._v("star,’ ” and encouraged her to tackle the “emotional and tragic parts” that she felt belonged to Hoffmann."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn143"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" As told in "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(", Modrzejewska initially refused these challenging roles so as not to offend Hoffmann, but when the latter replied that Modrzejewska was being “very wise” because she “could not possibly play dramatic heroines,” their competition began with a bang. A provoked Modrzejewska returned to Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski and was handed a pile of "), _c('em', [_vm._v("sixty")]), _vm._v(" roles to prepare, including tragic leads."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn144"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/48.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("Actress Antonina Hoffmann (1842–1897). Photo by Walery Rzewuski. Courtesy of the Kraków City History Museum")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("Indebted to Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski for this pivotal support, Modrzejewska stayed in touch with him long after he was deposed, asking him for advice less often than the clearly doting actor wished and enlisting his aid for her Warsaw debut."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn145"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" Modrzejewska was Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski’s most famous “grateful pupil,” though other actors, including Rapacki, benefited from Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski’s fine coaching."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn146"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" Her gratitude also implied criticism of his successor. By naming Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski her master and “theatrical father,” Modrzejewska preemptively denied Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian credit for her professional progress during her Kraków years."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn147"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian does appear from time to time in her memoirs, but as an incidental character, remarked only in passing as the standard-bearing “head of the Cracow theatre.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn148"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-2"
  }, [_vm._v("Modrzejewska ascribes other credit for her Kraków training to her brother Feliks and, not surprisingly, herself. Feliks, an actor who spent the bulk of his career in Kraków and was claimed by Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian as the archpupil of the Kraków School, figures in her memoirs as her mentor-partner, a more experienced, always loving, sexually innocuous co-star."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn149"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" When Modjeska recalls how very well she and Feliks worked together, she presents her training as the result of extraordinary family talent and drive rather than a director’s outside influence:")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("We used to rehearse at all hours, without regard for the proper time or place: at the supper-table after the performance, behind the scenes during the rehearsals, and mostly during our walks in the fields or under the chestnut trees of the Grand Alley. At the dinner table we were often rebuked by my mother or my brother’s beautiful wife for these eternal rehearsals. Felix would ask between the courses:—")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("“Helena, how does that scene begin?” and then we started. Sometimes we would discuss the meaning of the words, and in case we did not agree, we fell into such a heated argument that we had to be called to order. At other times we would find such natural expression for our lines that mother would take it for simple conversation, and then there was my brother’s triumphant exclamation:—")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("“You see, Helena, that was well done. Mother thinks we are having a chat.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn150"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("The young Helena who read Kraków for acting cues thus continued her self-styled training with her brother as fellow pioneer. She depicts how she herself maintained the relentless work ethic and anticipated the scholarly study and artistic collaboration identified as Kraków School practices. Her role preparation in Kraków embellished on the pacing and memorizing she did as a novice in Nowy S"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/a.jpg",
      "width": "9"
    }
  }), _vm._v("cz. In her memoirs, the young Kraków actress arose at five each morning and went out “into the open air” with her parts, reciting aloud as she walked up and down Chestnut Alley or Kraków’s Botanical Gardens."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn151"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" She recalls taking “a quantity of historical notes” about a part in preparation and researching her own costume for a historical drama in the Jagiellonian University Library, where the great bibliographer and her lifelong friend Karol Estreicher interceded on her behalf to request advice from the celebrated historical painter Jan Matejko."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn152"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" These solo forays would become standard practice for Kraków actors by the late 1870s. Then “every premiere” resulted from a ready collaboration between actors, artists, and scholars, as actor Roman "), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/zdot.jpg",
      "width": "9"
    }
  }), _vm._v("e"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/a.jpg",
      "width": "9"
    }
  }), _vm._v("zowski fondly remembered: “Painters designed costumes, set up studios for set design, painted the decorations needed for a specific play. Others browsed the Jagiellonian University Library to find us textbooks and commentaries for our roles and plays.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn153"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The self-guided Modrzejewska also dared public criticism of the new management."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn154"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" When the company was touring the resort town of Krynica in summer 1866, they went on strike against Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian, and Modrzejewska joined the protest. In "), _c('em', [_vm._v("Memories and Impressions")]), _vm._v(" she cannot recall the strike’s root cause, but cites the “bad melodramas” they were being forced to play as grounds enough for grievance."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn155"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" The scenario she describes contrasts a detached, displeased Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian to a spirited bunch of players living together “as one family.” More serious and portentous was Modrzejewska’s lone rebellion against the rushed pace of the Kraków Theatre’s performances."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn156"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" In May 1866, the normally indefatigable actress had to be replaced as a lead in Schiller’s "), _c('em', [_vm._v("Intrigue and Love")]), _vm._v(" after the programs had been printed. "), _c('em', [_vm._v("Time")]), _vm._v(" deplored the switch in high-handed terms, guessing that it was not the fault of the theater’s directors and warning that this incident conveyed a disrespect of the public that could spell a theater’s ruin."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn157"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" Modrzejewska’s answering salvo in "), _c('em', [_vm._v("Time")]), _vm._v(" constituted her print debut as a consummate theater professional. Her 4 May 1866 letter to the editor explained that her packed rehearsal and performance schedule allowed her a single day to prepare her part: “In truth I’m often given that little time to learn a role, but this is usually in a comedy where an artist may sooner rely on her own inspiration to fill in a forgotten line, and not in a tragedy by such a poet as Schiller!” Her request for a two-day postponement was denied. Modrzejewska put her case before the readers with utter confidence: “Would it not be disrespecting the public to perform without having "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("learned one’s role and studied one’s work? The performance was not postponed. Does this constitute disrespect on my part? Let the public judge.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn158"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("According to her actions and recollections, Modrzejewska retained a certain degree of independence in dealing with her directors and plotting her own professional course. She represented herself as a pioneering, hardworking contributor to, rather than pupil of, the new Kraków Theatre company. Her attitude toward Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian, the Kraków School’s supposed creator, was always professional, sometimes testy, and never quite subordinate. She seconded his love of the great dramatists, especially Shakespeare, whose works ennobled the theater they both sought to improve, and she respected his enormous industry and reforming zeal. But she would never pose herself listening raptly to his legendary analyses, as did younger actors under his direction."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn159"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" In Kraków, Modrzejewska was already set on becoming a theater phenomenon in her own right.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Yet Modrzejewska did learn a great deal on the job in Kraków under the favorable conditions that Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian was gradually shaping and in concert with other talented players on the Kraków stage. She typically shared the critics’ praise and the audience’s ovations with Rapacki and Hoffmann; Feliks’s performances were applauded less regularly. By her own account, she and her brother achieved “originality and exactness” in their performances of one-act French comedies."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn160"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" Modrzejewska and Rapacki continued to impress reviewers in their quite distinctive and equally well-executed roles, with Modrzejewska lauded for her graceful, natural, emotionally nuanced romantic heroines and Rapacki commended for his versatility, adeptness with makeup and costume, and commanding portrayals of patriarchs, villains, and colorful rogues. In a rare story of their work together backstage, Rapacki remembered how they collaborated with the author Miko"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aj Bo"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("ó"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/zgrav.jpg",
      "width": "8"
    }
  }), _vm._v("-Antoniewicz to breathe life into his “unscenic” ponderous verse drama "), _c('em', [_vm._v("Anna Oswi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("cimówna")]), _vm._v(". Modrzejewska and Rapacki constructed their respective roles (the eponymous Anna and her “proud, coarse, vengeful admirer” Laszcz) through private consultation with the playwright, who “explained to us what he could not articulate in his verses.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn161"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modrzejewska’s performance also improved through her keen rivalry with Hoffmann, whom she praises in retrospect as “highly gifted and much more experienced.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn162"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" As Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian shrewdly observed, the rivalry of these two strong talents, fueled by their contrasting looks, temperaments, and predilection for certain character types, generated competing claques of male supporters and "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("a stupendous boon for the theater."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn163"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" Comparing Hoffmann’s irregular features, expressive face, and lively manner with Modrzejewska’s classic beauty and dreamy temperament, Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian deemed Hoffmann suited to play dramatic, decisive characters and Modrzejewska perfectly cast as a lyrical heroine. The passionate Hoffmann figured as yang to the poetic Modrzejewska’s yin. Whereas Hoffmann reportedly stormed her audience by “frontal attack,” Modrzejewska gradually captivated them with a “faux passivity.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn164"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The rivals played exceedingly well together. Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian praised their excellence in such contemporary French plays as Alexander Dumas fils’ "), _c('em', [_vm._v("The Ideas of Madame Aubray")]), _vm._v(" as well as their legendary duet in the great Polish playwright Aleksander Fredro’s comedy of romantic errors, "), _c('em', [_vm._v("Maidens’ Vows")]), _vm._v(", with Hoffmann “typecast” as the sharp, insouciant Klara and Modrzejewska as the sweet, impressionable Aniela."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn165"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" Whatever their physical and temperamental differences, it seemed that Modrzejewska had absorbed certain key lessons from the more experienced Hoffmann. Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian implied and Got asserts that Modrzejewska rid herself of the “exaggeration and affectation” that she relied on in the provinces by observing Hoffmann at work."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn166"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" In effect, Hoffmann may have given Modrzejewska her most overt “instruction” in the Kraków School.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Due to Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s oversight, the repertoire that Modrzejewska played in Kraków was consistently more ambitious than what her troupes could sell in the provinces. But what most distinguished her progress over these years was her better, if not full, development of serious dramatic roles. Got provides the most astute summation of what Modrzejewska attempted and achieved in this period."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn167"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" He traces how she perfected her roles as the “first lover,” which required her projection of naïveté, dreaminess, and arch flirtation. At the same time, she began concentrated work on the great dramatic and tragic roles that Hoffmann had predicted she could not play. When Modrzejewska had tried such parts as Amelia in "), _c('em', [_vm._v("Mazepa")]), _vm._v(" and Barbara Radziwi"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("ówna on tour, her performances had been marred by the admixture of high pathos that the Kraków School expressly discouraged. In Kraków, Modrzejewska managed these roles with greater moderation and “true” emotion, at least in their romantic moments, although her reviews indicated that she still struggled to portray such complicated characters in their entirety, to convey thoughts and emotions that shot beyond the bounds of a “female sensitivity” she reliably portrayed.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/53.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("Modrzejewska as Aniela in Aleksander Fredro’s "), _c('em', [_vm._v("Maidens’ Vows")]), _vm._v(", 21 November 1865. Photo by Jan Mieczkowski. Courtesy of the Kraków City History Museum")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("This episodic and incomplete grasp of her character’s psychology also occurred in the first Shakespearean performances Modrzejewska attempted—Hero in "), _c('em', [_vm._v("Much Ado About Nothing")]), _vm._v(", Portia in "), _c('em', [_vm._v("The Merchant of Venice")]), _vm._v(", and even Ophelia and Juliet, two roles she eventually would make her signature masterpieces. Yet with increasing experience Modrzejewska sometimes succeeded as a dramatic heroine, as in her 12 January 1867 incarnation of Schiller’s Mary Stuart, when she truly rendered the gamut of the queen’s emotions “from shame, indignity, and humility to anger and an explosion of the strongest passion.” One of her reviewers recognized her “complete” achievement that night: “The duration of this role and its emotional struggles did not tire the actress, and whenever her role departed from its normal track, she would soar like an eagle.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn168"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("On the Kraków stage, Modrzejewska was learning to master the sorts of roles that would enhance her performance on the social stage of the city. In the second half of the nineteenth century, French melodramas and comedies exerted a powerful influence throughout Europe, and these plays usually featured the locus and characters of aristocratic society. The best French actors were said to reproduce their native aristocrats’ real gestures, behavior, and conversations in the salon—a feat captured in the Polish term "), _c('em', [_vm._v("salonowo"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/sgrav.jpg",
      "width": "6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/cgrave.jpg",
      "width": "8"
    }
  })]), _vm._v("—and Polish actors were admonished to emulate either their French counterparts or local aristocrats."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn169"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" As Kosi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski remarks: “the idealized salon was a role model for the stage.… Incarnating that model, the theater not only affirmed, but also popularized its worth, and served in turn as a role model for those who would never set foot in a salon.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn170"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-2"
  }, [_vm._v("Achieving "), _c('em', [_vm._v("salonowo"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/sgrav.jpg",
      "width": "6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/cgrave.jpg",
      "width": "8"
    }
  })]), _vm._v(" was therefore most desirable for the Polish and particularly the Kraków actor. Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian looked to the Kraków aristocracy to model and encourage the right behavior for his actors assaying salon roles."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn171"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" He castigated his class peers for not filling the loggias and stalls that French and Austrian aristocrats occupied in their theaters, and thus not serving as examples for the performers:")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("I often hear this unfortunately apt complaint about our actors and actresses—“But no one behaves that way in a salon!” You are right, dear madame! But aren’t you partly at fault? If you were a regular patron of the theater, your smile, your satisfaction, your applause or your turning aside to whisper a criticism to your neighbor would be ample instruction, for your presence would create that magnetic human bond between actress and lady, and help a Polish actress, who is not at all a great "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("lady, to become one onstage, just as a French actress does, although she is even less a lady offstage."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn172"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_vm._v("Modrzejewska early evinced an aptitude for incarnating great ladies in the showcase salon roles of contemporary French dramas."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn173"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" Playing the part of Genowefa in Victorien Sardou’s "), _c('em', [_vm._v("Our Good Countryfolk")]), _vm._v(", Modrzejewska was said to rival the French actress Delaporte, whose performance of this role in Paris had elicited Foucher’s famous aphorism: “Si le mot de perfection n’existait pas, il faudrait l’inventer pour elle.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn174"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" During Modrzejewska’s years in the Kraków Theatre, the aristocrats had not yet drifted away from their subscription seats, and both the stage and the stalls afforded Modrzejewska an intensive, effective “finishing school.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-2"
  }, [_vm._v("While Modrzejewska was winning acclaim as a lady onstage, she also sought to remain that lady when she left the theater. Ever since she had debuted as Madame Modrzejewska, she had assumed the somewhat less vulnerable public persona of a professional actress wed to her agent-manager. Having abandoned this liaison and its failed script, she cultivated a new role determined in large part by her work-driven life. Kazimierz Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("dowski, one of her disappointed suitors who settled for friendship, portrayed her as a cloistered miss, an actress who seemed positively nunlike in pursuing her vocation. A kind of revirginalized Modrzejewska")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("lived with her mother and brothers on Floria"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ska Street. A visitor first entered the large room of her mother, a very nice older lady, and was announced by their shrilly barking little dog. The artist lived in a second, narrow room with a window facing onto the courtyard. A couch covered in oilcloth, a bed with a white spread, several chairs, a little desk picked up from the Jewish furniture shops on Szpitalna Street, and an even smaller dressing table with an attached mirror—these were the sole furnishings of her modest apartment. On the table lay several play scripts and a large book in French containing the biographies of the greatest actresses."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn175"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_vm._v("Modrzejewska projected an image of admirably chaste ambition, retreating behind mother and dog to the equivalent of a convent cell with its few scattered objects of devotion. Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("dowski wrote in awe of her love of art and incessant self-improvement: “The young artist worked hard on herself, beginning to study French, reading a great deal, and, despite her modest means, dressing herself in excellent taste.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn176"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" Her beloved son, Dolcio, evidence of her immoral past, had been absorbed into the capacious Benda family. When Zimajer kidnapped the five-year-old in May 1866, Modrzejewska’s suddenly "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _vm._v("cancelled performance was the only public sign of her distress. Behind the scenes, a frantic mother strived to ransom him from his father until Zimajer relented, for the right price, in 1869. Ironically, her son’s long absence reinforced the impression of her chaste dedication."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn177"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In Kraków, surrounded by family and with stable employment, Modrzejewska first operated as a professional woman without an intervening manager. As her talent and stardom became more apparent, she found herself in the position of broker and benefactor. Her co-star Rapacki fondly recalled that Modrzejewska “enchanted people with her intelligence as well as her charm. Throngs of society’s elite surrounded her. A host of counts and non-counts took up the pen.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn178"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" Modrzejewska’s letters reflected how she both inspired and commissioned new dramas. Jan Aleksander Fredro, the son of Poland’s greatest living playwright, dedicated a piece to her in November 1867."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn179"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" In her never-ending quest for good roles, Modrzejewska apparently encouraged W"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("adys"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("aw Umiastowski to “refine” Dumas fils’ "), _c('em', [_vm._v("Lady of the Camellias")]), _vm._v(" for Polish production, for a play about a courtesan was still deemed too provocative for Polish audiences."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn180"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The most influential of Modrzejewska’s “counts and non-counts,” however, was Count Aleksander Prze"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/zgrav.jpg",
      "width": "8"
    }
  }), _vm._v("dziecki. A historian, writer, collector, and man of considerable cultural influence, Prze"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/zgrav.jpg",
      "width": "8"
    }
  }), _vm._v("dziecki was a frequent, well-known visitor to Kraków."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn181"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" As the Count explained in a 16 February 1867 letter to the actress, he dedicated to her his Polish adaptation of the play "), _c('em', [_vm._v("After the Ball")]), _vm._v(" ("), _c('em', [_vm._v("Le lendemain d’un bal")]), _vm._v(") “in commemoration of the pleasant moments spent in Kraków” in fall 1866."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn182"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" When Modrzejewska thanked him, wondering if she “deserves so much of [his] kindness,” she may have been acknowledging his social prowess or testing the purity of his motives."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn183"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" By the following year, Prze"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/zgrav.jpg",
      "width": "8"
    }
  }), _vm._v("dziecki had become her mighty champion, helping her negotiate her guest performances in the Warsaw Imperial Theatres."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn184"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modrzejewska was drawn, to a limited extent, into Kraków society, where she was in the curious position of being a professional actress in a highly theatricalized real world. The tone-setting Kraków aristocrats were ever on public display in their sumptuous amusements—their great balls, sleigh ride parties, masques, and, of course, amateur theatricals. The Potocki family balls, held in Pod Baranami, their in-town palace, provided seasonal spectator sport and were emulated on a lesser scale by middle-class and professional associations. As Estreicherówna recalls, at Pod Baranami “the palace halls were covered in carpets, mirrors and flowers bedecked the stairs, a doorman with a "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _vm._v("halberd stood at the gate, and a police guard on the street patrolled the crowds swarming to catch a glimpse of arriving guests.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn185"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])]), _vm._v(" The aristocrats’ amateur theatricals, often performed in French, which many of the players knew better than Polish, were reviewed in the Kraków press."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn186"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v(" When Helena Sanguszko, the princess rumored to be Modrzejewska’s half-sister, appeared in an amateur tableau vivant"), _c('em'), _vm._v(", she impressed the reviewer in "), _c('em', [_vm._v("Time")]), _vm._v(" with her great beauty, and her tableau received the equivalent of three curtain calls."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn187"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Professional actors participated in these amateur extravaganzas, but mainly as instructors and advisers. We know that Modrzejewska’s sister-in-law, Weronika Bendowa, gave dancing lessons for ball-goers in her home and, according to Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("dowski, Modrzejewska would then emerge from her metaphorical cell to even out the male-female dancing pairs. In so doing, the actress risked some censure; Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "13",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("dowski noted that male dance students outnumbered the females because “Kraków families didn’t want to send their daughters to the home of an actress.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn188"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" Yet Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian pointed out that over the course of Feliks Benda’s career “no amateur theater in [Kraków] high society managed without [him], for he usually organized and directed [these performances].”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn189"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])]), _vm._v(" Feliks became a favorite of the Potockis and other first families."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn190"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The Kraków aristocrats’ amateur pastimes were therefore deftly dramatic, produced with specialist input, and pursued with the awareness that the general public was watching, envying, imitating, and reporting on them. The aristocrats were, in effect, the most admired performers in the city, but their talent stemmed from “inborn superiority” rather than acquired professional skill. Any successful impersonation of their public behavior therefore had to be natural and realistic within the desired aesthetic parameters of the day, unmarred by vulgarity, exaggeration, or preciousness. Modrzejewska strived to play refined, charismatic ladies without discernible dramatic effect offstage as well as on. She was an actress facing the ultimate challenge, projecting herself as a woman whose virtuosity was her nature, not the hard work of a déclassé professional. Modrzejewska easily succeeded in the theater, where she was judged as a fictitious character. Offstage, she encountered greater difficulty because she could not wholly erase her real-life profession, class, and past in the minds of her beholders.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Kietli"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ska’s diary records mixed reviews of Modrzejewska in society. The Kraków native declared herself to be “like most women … a most avid fan of this brilliant and entrancing artist,” but she knew only the onstage Modrzejewska. She first met her “ideal” in person at a ball. “I’ll never forget how I "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _vm._v("felt when she gave me her hand and her beautiful kindly eyes gazed at me,” the elderly diarist remembers. “I remained under the spell of her indescribable charm the rest of my life.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn191"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" But Kietli"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ska had come under the real Modrzejewska’s spell because she had to replace a huffy Miss Zieleniewska who refused “to dance with an actress in the same circle.” Modrzejewska clearly could not bewitch those who made no exception to the class rules.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-2"
  }, [_vm._v("Modjeska’s memoirs strategically depict her winning the highest stamp of approval from Kraków’s most distinguished family, the Potockis. The actress recalls that she behaved with intuitive correctness when she chanced on the married Count Adam Potocki in the park, “a very handsome, tall, and distinguished-looking man” whom she neither recognized nor permitted any familiarity."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn192"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])]), _vm._v(" Her reserve was appreciated by the count’s wife and mother. In consequence, Modrzejewska was invited to pay a visit to his mother, Countess Arturowa Potocka, Kraków’s most socially committed philanthropist and a key supporter of the theater. During this audience, Modrzejewska studied the natives in the drawing room: “those aristocratic ladies were utterly simple, without a grain of snobbishness in their manner. Their grace was like the grace of children, unconscious of their beautiful movements which, however, were marked with reserve acquired through early training.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn193"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])]), _vm._v(" When Potocka spoke with Modrzejewska in private, however, she declared that the actress needed no template to play these ladies right. The comments the actress recollects authorize her exceptional ability to pass for an aristocrat:")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("[Potocka] added, laughing, “You are as clever as a snake. You played the other evening the countess in ‘The White Camelia’ as if you were born among us. Where did you meet countesses?”")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("I answered that she was the only great lady I had ever laid eyes on.")]), _vm._v(" "), _c('p', {
    staticClass: "extract-indent"
  }, [_vm._v("“You see,” said she, “that was "), _c('em', [_vm._v("intuition")]), _vm._v(". Other actresses, when they represent women of nobility, or princesses and queens, walk with a straight, rigid spine, as if they had swallowed a stick. They sometimes in modern comedies resort to a lorgnette, looking snobbishly on people and examining them from head to foot, with a silly, superficial smile. Thank Heaven, you have none of that insipid nonsense. You are simple, and that is right.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_vm._v("By summer 1866, Modrzejewska was contemplating a bolder class advance by choosing the right husband. Her marriage to Karol Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski, a Pozna"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v(" aristocrat and a veteran of the 1863 uprising, would gain her admission to a number of high society circles in Warsaw. Their courtship during her Kraków years was more complex than the usual tales of the actressocracy, in which beautiful women of the stage married handsome noblemen for love, money, "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v("and release from their profession. In Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski, Modrzejewska discovered an aristocrat who not only appreciated her ability to act as if she “were born among us,” but also admired her as a great artist in a most absorbing profession. Even as she was playing for approval and acceptance, Modrzejewska happily found Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski to be an aristocrat whom she could marry on her own terms.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("From the start of their relationship, Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski was integrated into Modrzejewska’s theatrical family, as Zimajer and other Benda partners had been, although Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski’s involvement entailed social risk and valor. A member of a prominent aristocratic family in Pozna"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v(", in the Prussian partition of Poland, Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski was the son of a baron and the grandnephew of General Dezydery Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski, who had served the Polish cause under Napoleon and had fought in the November 1830 uprising against the Russians. Raised in France and Belgium and enrolled for a time in the University of Louvain, Karol Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski was one of those Polish aristocrats whose French surpassed and accented his Polish."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn194"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])]), _vm._v(" At first, he appeared to be more the comical character actor than the romantic lead, “a nearsighted man with the inevitable pince-nez on a black cord, an absentminded fellow constantly losing things or putting them in the wrong place, a chatterbox and occasional politician.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn195"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])]), _vm._v(" Yet by the time Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski laid eyes on Modrzejewska during the Kraków Theatre’s summer 1866 tour of Pozna"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v(" and Krynica, he was piecing together a life blown apart by his ordeals in battle and prison. The dilettantish, directionless Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski was a casualty of the 1863 uprising. He had abandoned a world of privilege to fight alongside the rebels, and when he was wounded and sent home, the Prussian authorities had clapped him into Berlin’s Moabit Prison for twenty months.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("By summer 1866, Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski had returned to Pozna"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v(", where he “was dabbling in theatre and journalism” and going to plays with his equally theater-addicted cousin, Tadeusz."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn196"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])]), _vm._v(" While charming comedies and pretty actresses offered welcome diversion to other young war-weary veterans, the twenty-five-year-old Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski was developing into an astute man of the theater and fraternized with actors in good part to talk shop. Modjeska remembers first seeing him from the stage, breaking her own concentration during a performance to study “his mobile face, a slightly sarcastic smile, and the absorbed interest with which he caught the slightest shadings in the actor’s words and actions.” When she read his “severe dissection” of her wandering attention in the next morning’s paper, she “liked him for his sincerity all the more for "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _vm._v("[she] knew he was right.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn197"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])]), _vm._v(" She introduces readers to her suitor Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski not as a stage door Johnny, but as a fellow professional who knows his business. Here the star pointedly cedes the limelight to her critic.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Over the next few months, Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski pursued Modrzejewska openly and threw himself into her professional circle and plans. After her company’s stint in Pozna"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v(", he followed them to Krynica, where he “assimilated himself at once with our improvised family and took part in our meetings and excursions.” According to an odd gossip-column-cum-theater-review in "), _c('em', [_vm._v("Time")]), _vm._v(", Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski’s almost simultaneous arrival with the Kraków company (he is referred to as “a certain "), _c('em', [_vm._v("gentleman")]), _vm._v(" from Pozna"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("”) piqued the locals’ curiosity: “This young man strolls about as cool as you please and surely does not know that he has become the mystery of Krynica—bah! today’s big man about town.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn198"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])]), _vm._v(" The aristocrat and the actress seemed bound for each other. While Modrzejewska was eagerly training to act naturally as a lady, Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski was presuming to pass as boon companion of the troupe.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Already in Pozna"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v(", Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski began investing in Modrzejewska’s future career elsewhere, reading to her the poetry of de Musset, Chateaubriand, and Lamartine and taking “a great deal of pains ["), _c('em', [_vm._v("sic")]), _vm._v("] to correct [her] bad French.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn199"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" To some extent, he was reprising Zimajer’s role with his French lessons, although Modrzejewska offered him reciprocal instruction in Polish language and literature. A year younger than his beloved, Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski approached her as peer rather than protégée. By fall 1866, when Modrzejewska was granted a six-week vacation, Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski joined her and her brother Feliks on a trip to Paris, where he orchestrated their instructive visits to the Théâtre Français, the Gymnase, the Odeon, the Théâtre du Vaudeville, and the Palais Royal. Whatever his romantic designs on the beautiful actress, this young aristocrat never questioned the primacy of her career.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("It is not altogether clear what role Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski played in that career after their Parisian trip and before their wedding—whether he advised her, for example, to agree to the guest appearances she made in Lwów in May 1867 or what opinions he shared about her role choices and interpretations. The Kraków Theatre company toured Pozna"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v(" again in the summers of 1867 and 1868 and Modrzejewska thereafter vacationed with Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski in either Krynica or Zakopane, a hamlet in the Tatra mountains which would soon rival Krynica as a tourist destination. Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski cropped up in her correspondence in June 1868, when he played secretary for an ailing Modrzejewska as she continued to negotiate her Warsaw debut with Prze"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/zgrav.jpg",
      "width": "8"
    }
  }), _vm._v("dziecki."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn200"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")])]), _vm._v(" Three "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _vm._v("months later, on 12 September 1868, the actress and her suitor-secretary were married in St. Anne’s Church in Kraków, on the verge of Modrzejewska’s next move upward.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Modrzejewska’s acceptance by the Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski family would require careful cultivation and never be complete, since Karol’s eldest brother Maciej did not recognize their union."), _c('sup', [_c('a', {
    attrs: {
      "id": "rch2fn201"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch2fn201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])]), _vm._v(" Nonetheless, their classic mésalliance worked to their immense mutual satisfaction. The young veteran Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski fell in love with a woman whose profession represented another great passion in his life. Although he would pursue other, often costly, projects during their marriage, Modrzejewska’s artistic genius steadied him with a much-needed direction and purpose. Modrzejewska discovered in Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski the right man for the rest of her life and work. Unlike the unmarried Hoffman and the retired Maria "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("Ł")]), _vm._v("agowska, Modrzejewska had become involved with an aristocrat who made her his wife and revolved around her career. Her escape from Zimajer and her wildly successful years in Kraków clarified for her what she desired and would tolerate in a partner. She knew well the limits of an irregular liaison, however it might be represented to the public. Although she worked tirelessly to play the great lady onstage and in society, her primary passion, like Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski’s, was for the theater, and she had no wish to marry away from it. Nor did she want or need another husband-manager, at least for the foreseeable future. Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski offered Modrzejewska everything but a fortune—legitimate marriage, ebullient companionship, professional expertise, and an aristocratic partnership into which she and her fellow actors were welcomed as peers.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Shortly after their wedding, Modrzejewska and Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski departed for Warsaw, where her spectacular debut spelled the end of the Kraków stage of her career. This intensive period had been extremely important in polishing and furthering her talent, if not forming her basic approach. Her three years with the revitalized Kraków Theatre of Skorupka and Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian had honed her diction, mimicry, gestures, and part preparation and had expanded her range of roles. Modrzejewska benefited from the theater’s better management, its greater local prestige and patronage, Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian’s ambitious choice of repertoire, the directors’ and actors’ commitment to more thoughtful role analysis and extensive rehearsing, and performing with other fine actors in her company.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Yet the Kraków-born Modrzejewska who so quickly attained stardom in the new Kraków Theatre was the first player to abandon it for Warsaw’s larger "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _vm._v("opportunities. Despite her enormous workload and grinding schedule, she never lost sight of her individual agenda and cultivated her supporters and mentors to help her realize it. In retrospect, she would identify Jan Jasi"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/n.jpg",
      "width": "9"
    }
  }), _vm._v("ski and her brother Feliks as her chief Kraków influences instead of paying the expected homage to Ko"), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "14",
      "src": "images/szgrav.jpg",
      "width": "8"
    }
  }), _vm._v("mian. She implied that her intensive, innovative training was mainly her own idea. After three years of hard labor, Modrzejewska sought a professional sinecure that would give her greater control over her time and career, and a high society that she could enter as an established artist and a respectable lady. By autumn 1868, the young Helena who had prostrated herself on the floor of the Dominican Church emerged from the Church of St. Anne as the wife of an aristocrat and a local star deemed worthy of Warsaw’s consideration. Up to this point, Helena’s extraordinary self-transformation roughly paralleled that of her hometown. But Modrzejewska needed the big-city stage of Warsaw to unfurl her national greatness.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/62.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _vm._v("Modrzejewska and her husband, Karol Ch"), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("ł")]), _vm._v("apowski, in 1869. Courtesy of the Kraków City History Museum")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15feb9e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter_002.vue
// module id = 87
// module chunks = 0